// src/ButtonList.js
import React from 'react';

const PodcastCategoryList = ({ items, onButtonClick }) => {
  return (
    <ul>
      {items && items.map && items.map((item, index) => (
        <li>
        <button key={index} onClick={() => onButtonClick(item)}>
          {item.category}
        </button>
        </li>
      ))}
    </ul>
  );
};

export default PodcastCategoryList;
